<template>
  <div>
    <div
      v-if="isVisitorsProfileDurationLoading || isCompetitorsFetching"
      class="tw:h-[425px] tw:bg-gray-300 tw:animate-pulse tw:rounded-lg"
    ></div>
    <div v-else-if="isVisitorsProfileDurationError" class="tw:h-[425px]"></div>
    <div v-else>
      <CompetitorsComparisonTable :columns="columns" :timeFrame="timeFrame" :tableData="visitorsProfileDuration" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import CompetitorsComparisonTable from '@/components/visitorsProfile/common/CompetitorsComparisonTable.vue'
import { useVisitorsProfileDuration } from '@/components/visitorsProfile/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCompetitors } from '@/components/rateInsights/queries'

const props = defineProps({
  timeFrame: {
    type: String,
    required: true,
    default: '30',
  },
})

const { isCompetitorsFetching } = useCompetitors(selectedAccommodationId)

const timeFrameSelected = computed(() => props.timeFrame)
const { isVisitorsProfileDurationLoading, isVisitorsProfileDurationError, visitorsProfileDuration } =
  useVisitorsProfileDuration(timeFrameSelected)

const columns = {
  lte2days: 'vp_graph_1night',
  days34: 'vp_graph_2nights',
  days56: 'vp_graph_4nights',
  days78: 'vp_graph_6nights',
  gte9days: 'vp_graph_8nights',
}
</script>
